/**
 * Единая точка получения origin приложения.
 *
 * Ссылки на проекты/задачи/документы должны указывать на ту среду, в которой
 * они были скопированы (dev / stage / prod), поэтому origin всегда берётся из
 * текущего окна, а не из собранных на этапе билда констант.
 *
 * VITE_APP_PUBLIC_ORIGIN — необязательный override для случаев, когда фронт
 * открыт по служебному адресу (например, внутренний IP или порт превью),
 * а делиться нужно каноническим публичным адресом среды.
 */
export function getAppOrigin(): string {
    const configuredOrigin = import.meta.env?.VITE_APP_PUBLIC_ORIGIN

    if (typeof configuredOrigin === 'string' && configuredOrigin.trim()) {
        try {
            return new URL(configuredOrigin.trim()).origin
        } catch {
            // Некорректный override игнорируем и падаем обратно на текущий origin.
        }
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin
    }

    return ''
}

/** Собирает абсолютную ссылку внутри приложения для текущей среды. */
export function buildAppUrl(path: string): URL {
    return new URL(path, getAppOrigin() || undefined)
}
